import Vue from 'vue'
import App from './app'

Vue.config.productionTip = false

export default function (store, router, template) {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: template || '<app/>',
    components: {App}
  })
}



// WEBPACK FOOTER //
// ./app/resource/entry.js